import { AppHeaderV2 } from '@atlassian/mpac-ui';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListingHeader = _ref => {
  let {
    appHeaderDetails,
    appRatingLink,
    appIconLink,
    bottomSeparator,
    headerInjection,
    isAppCloudFortified,
    showInstallationCount,
    openMarketplaceLinksInNewTab,
    bugBountyParticipant,
    compatibilitySummary,
    lozenges,
    hostingSelect
  } = _ref;
  return /*#__PURE__*/_jsx(AppHeaderV2, {
    appHeaderDetails: appHeaderDetails,
    appRatingLink: appRatingLink,
    appIconLink: appIconLink,
    bottomSeparator: bottomSeparator,
    headerInjection: headerInjection,
    isAppCloudFortified: isAppCloudFortified,
    showInstallationCount: showInstallationCount,
    openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
    bugBountyParticipant: bugBountyParticipant,
    compatibilitySummary: compatibilitySummary,
    lozenges: lozenges,
    hostingSelect: hostingSelect
  });
};